import React from 'react';
import { Box, Inscription, RoundCloseIcon } from '@common-fe/common-fe';

interface Props {
  children?: React.ReactNode;
}

const ErrorSnack: React.FC<Props> = ({ children }) => (
  <Box
    height={{ min: '40px' }}
    background="dangerContainer"
    round="snackbarRound"
    border={{ color: 'dangerBorder' }}
    justify="between"
    align="center"
    direction="row"
    pad={{ vertical: '10px', horizontal: '14px' }}
  >
    <Box align="center" direction="row">
      <RoundCloseIcon size="20px" color="danger" />
      <Inscription margin={{ left: '10px' }}>
        {`Please review the errors and
          submit a new file with the corrected records.`}
      </Inscription>
    </Box>
    {children}
  </Box>
);

export default ErrorSnack;
